document.querySelectorAll('#jv-pdp').forEach((root) => {
  const variants = JSON.parse(root.querySelector('script[type="application/json"]').textContent);
  const q = (s) => [...root.querySelectorAll(s)];
  let sel = variants.find((v) => v.sel).o.slice();
  const slides = root.querySelector('.jvp-slides');
  const thumbs = q('.jvp-thumbs button');

  const match = (o) => variants.find((v) => v.o.every((x, i) => x === o[i]));
  const render = () => {
    const v = match(sel);
    q('[data-opt]').forEach((b) => b.classList.toggle('jvp-on', sel[b.dataset.opt] === b.dataset.val));
    q('.jvp-ol').forEach((e) => (e.textContent = sel[e.dataset.opt]));
    q('.jvp-pk').forEach((b) => {
      const pv = match(sel.map((x, i) => (i === +b.dataset.opt ? b.dataset.val : x)));
      b.querySelector('.jvp-pr').firstChild.textContent = pv ? pv.p : '';
      const s = b.querySelector('.jvp-pr s');
      s.textContent = pv && pv.c ? pv.c : '';
    });
    if (!v) { q('.jvp-atc').forEach((b) => (b.disabled = true)); return; }
    root.dataset.variant = v.id;
    q('.jvp-sp').forEach((e) => (e.textContent = v.p));
    q('.jvp-ss').forEach((e) => { e.textContent = v.c; e.hidden = !v.c; });
    q('.jvp-pill').forEach((e) => { e.textContent = v.save; e.hidden = !v.save; });
    q('.jvp-atc').forEach((b) => { b.disabled = !v.a; b.textContent = v.a ? b.dataset.add : b.dataset.sold; });
  };
  q('[data-opt]').forEach((b) => b.addEventListener('click', () => { sel[+b.dataset.opt] = b.dataset.val; render(); }));

  const go = (k) => {
    const w = slides.clientWidth;
    slides.scrollTo({ left: Math.max(0, Math.min(k, thumbs.length - 1)) * w, behavior: 'smooth' });
  };
  slides.addEventListener('scroll', () => {
    const k = Math.round(slides.scrollLeft / slides.clientWidth);
    thumbs.forEach((t, i) => t.classList.toggle('jvp-on', i === k));
  });
  thumbs.forEach((t, i) => t.addEventListener('click', () => go(i)));
  root.querySelector('.jvp-arr.jvp-l').addEventListener('click', () => go(Math.round(slides.scrollLeft / slides.clientWidth) - 1));
  root.querySelector('.jvp-arr.jvp-r').addEventListener('click', () => go(Math.round(slides.scrollLeft / slides.clientWidth) + 1));

  const msg = root.querySelector('.jvp-msg');
  q('.jvp-atc').forEach((b) => b.addEventListener('click', async () => {
    b.disabled = true;
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: root.dataset.variant, quantity: 1 }),
    });
    if (!r.ok) { msg.textContent = (await r.json()).description; b.disabled = false; return; }
    location.href = '/cart';
  }));
  q('.jvp-go').forEach((a) => a.addEventListener('click', (e) => {
    e.preventDefault();
    root.querySelector('.jvp-buy').scrollIntoView({ behavior: 'smooth' });
  }));

  const sticky = root.querySelector('.jvp-sticky');
  const mainAtc = root.querySelector('.jvp-buy .jvp-atc');
  new IntersectionObserver(([e]) => sticky.classList.toggle('jvp-show', !e.isIntersecting && e.boundingClientRect.top < 0)).observe(mainAtc);
  q('.jvp-pk').forEach((b) => b.addEventListener('keydown', (e) => (e.key === 'Enter' || e.key === ' ') && b.click()));
  render();
});
